export class AuditLogStateChange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<AuditLogFieldChange>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogStateChange.attributeTypeMap;
    }
    constructor() {
    }
}
